import { UIComponentState, UIComponentHandler } from '../../../../toolkit/uicomponent';
import * as React from 'react';
import { ToneDto } from '../../../../../core/dto/tonedto';
import { BaseContext } from '../../../../../utils/basecontext';
import { CRBTUIViewImpl } from '../../crbt/crbtuiview';
import { Strings } from '../../../../../utils/resources/strings';
import { PopUpWrapperComponent } from '../../../popup/popupwrappercomponent';
import { GridComponent, GridComponentProps } from '../../../../toolkit/grid/gridcomponent';
import { AlertType } from '../../../../toolkit/alert/alerttype';
import { AlertComponent } from '../../../../toolkit/alert/alertcomponent';
import { NoResultComponent } from '../../../nametunes/noresult/noresultcomponent';
import { LoaderComponent } from '../../../../toolkit/loader/loadercomponent';
import { LoaderWrapperComponent } from '../../../popup/loaderwrappercomponent';
import { ShowMoreFeaturedCategoryToneViewModelImpl } from './showmorefeaturedcategoryviewmodel';
import { ShowMoreFeaturedCategoryComponentProps, ShowMoreFeaturedCategoryComponentState } from './showmorefeaturedcategorycomponent';
import './showmore-style.css';
import { ShowMoreFeaturedCategoryCSSStyle } from './showmorefeaturedcategorycss';
import { RoutingFeatures } from '../../../navigation/routingfeature';

export class ShowMoreFeaturedCategoryViewImpl extends CRBTUIViewImpl
{
    popUpComponent: PopUpWrapperComponent;
    ref: GridComponent<GridComponentProps<ToneDto>, UIComponentState>;
    private loaderWrapperComponent:LoaderWrapperComponent;

    constructor(private featuredCategoryListViewModel: ShowMoreFeaturedCategoryToneViewModelImpl,context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);
    }

    bindHandlers()
    {
      
        this.closePopup = this.closePopup.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.dismissLoader = this.dismissLoader.bind(this);
        this.backClicked = this.backClicked.bind(this);
    }

    getChildComponent(props:ShowMoreFeaturedCategoryComponentProps,state: ShowMoreFeaturedCategoryComponentState, cssStyle: ShowMoreFeaturedCategoryCSSStyle): JSX.Element
    {
        return (
            <>
             {
                         this.featuredCategoryListViewModel.getListOfDatas().length > 0 &&
            <div>
             <div id="showmore-main-div" style={{}}>
                <div id="showmore-title-div" style={{}}>
                <label id="showmore-title-label" style={cssStyle.getTitleCSSStyle()}>{props.title}</label>
                </div>
                <h2 onClick={this.backClicked} id="back-label" style={(cssStyle.getBackCSSStyle())}>{this.getUIProps().context.getResources().getString(Strings.back_arrow)}</h2>
            </div>
              <div id="show-more-tonecard-list">
                <GridComponent ref={(item: any) => this.ref = item} listViewModel={this.featuredCategoryListViewModel} context={this.getUIProps().context}/>
             </div>
            <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={this.getUIProps().context}/>
            
           </div>
           }
           {
        state.isDataNotLoaded &&
        <div style={{width:'100%',height:'100%',marginBottom:'50px'}}>
               <NoResultComponent   context={this.getContext()}/>
        </div>    
      }
       <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
              
           </>
        );
    }

    getNavigationPath()
    {
        return [this.getUIProps().context.getResources().getString(Strings.home), this.getUIProps().context.getResources().getString(Strings.categories)];
    }
    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }

    backClicked()
    {
        console.log("backClicked invoked");
        this.getUIProps().context.getRedirectionHandler().routeNextFeature(RoutingFeatures.HOME, false);
    }
    getBannerImg()
    {
        return "banner.jpg";
    }
    
    setListOfDatas(listofTones: ToneDto[])
    {
        this.featuredCategoryListViewModel.setListDatas(listofTones);
    }
    closePopup()
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }
    showPopup(msg:string,type:AlertType):void
    {
        
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);
}
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/showmorefeaturedcategory/showmorefeaturedcategoryview.tsx